import { render } from "./RegisterEmployee.vue?vue&type=template&id=13821a85"
import script from "./RegisterEmployee.vue?vue&type=script&lang=js"
export * from "./RegisterEmployee.vue?vue&type=script&lang=js"

import "./RegisterEmployee.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__